import { Component, OnInit } from '@angular/core';
import { CommanSubscribeService } from '../core/services/comman-subscribe.service';

@Component({
  selector: 'app-sample-theme-page',
  templateUrl: './sample-theme-page.component.html',
  styleUrls: ['./sample-theme-page.component.scss']
})
export class SampleThemePageComponent implements OnInit {
  themeColors:any;

  constructor(
    public commonSubscribeService: CommanSubscribeService
  ) { }

  ngOnInit() {
    this.themeColors = this.commonSubscribeService.getThemeColors();
    console.log(this.themeColors)
  }

}
